import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import RadioButton from "../../../generic/radioButton";
import { IListObj } from "../../../types/genericTypes";
import { AddNewNominee } from "./addNewNominee";
import {getinvAccDet} from "../../../service/login/loginService"
import { OptOut } from "./optOut";
import { Replication } from "./replicate/replicate";
import { GetNomineeDetails, createServiceReqNomin, CreateServiceRequestDetails } from "../../../service/serviceRequest/srApiService";
import { StatusScreen } from "../../generic/statusScreen";
const payMethod: Array<IListObj> = [
  { value: "replicate", display: "Replicate" },
  { value: "optOut", display: "Opt Out" },
  { value: "updateNominee", display: "Update Nominee" },
];
let invOnlyAcc = getinvAccDet();
const message: any = {
  replicate:
    "Nominee details as given in below table will be updated in Demat and/or Trading account as per your selection.",
  updateNominee:
    "In case you wish to update nominee in your Demat and/or Trading account, please enter nominee details. This nomination shall supersede any prior nomination made by the account holder(s), if any.",
  optOut:
    "I / We hereby confirm that I / We do not wish to appoint any nominee(s) in my / our trading / demat account and understand the issues involved in non-appointment of nominee(s) and further are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents / information for claiming of assets held in my / our trading / demat account, which may also include documents issued by Court or other such competent authority, based on the value of assets held in the trading / demat account.",
};

const Invmessage: any = {
  replicate:
    "Nominee details as given in the below table will be updated in the Investment account as per your selection.",
  updateNominee:
    "In case you wish to update nominee details in your Investment account, please enter nominee details. This nomination shall supersede any prior nomination made by the account holder(s), if any.",
  optOut:
    "I / We hereby confirm that I / We do not wish to appoint any nominee(s) in my / our Investment account and understand the issues involved in non-appointment of nominee(s). Further, I / We are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents / information for claiming assets held in my / our Investment account, which may also include documents issued by a Court or other such competent authority, based on the value of assets held in the Investment account.",
};


export const Nomination = forwardRef((props: any, ref: any) => {
  const [nominType, setNominType] = useState<any>(payMethod[1].value);
  const [existingNominationSR, setExistingNominationSR] = useState("");
  const [nomineeDet, setNomineeDetails] = useState<any>([]);
  const [nomineeForm, setNomineeForm] = useState({
    selectedDp: "", tradingUpd: false, dematUpd: false, nominees: []
  });
  const [reqObj, setReqObj] = useState<any>({});
  const nominee: any = useRef();
  const [serviceReqListArr, setServiceReqListArr] = useState<any>();
  let storedList = window.sessionStorage.getItem("serviceReqList");
  React.useEffect(() => {
      setServiceReqListArr(storedList ? JSON.parse(storedList) : []);
  }, [storedList]);
  useImperativeHandle(ref, () => ({
    submitData(val: any) {
      submitForm();
    },
  }));

  useEffect(() => {
    checkExistingNominSR();
  }, []);

  const isNomineePresent = (data: any) => {
    if (data) {
      let dpNomineesCount = data.DematDetails.filter((ele: any) => {
          return ele.DematTagging === "Nominee Available";
        }).length;

      return dpNomineesCount > 0;
    }
  };
  const getNomineeDetails = async () => {
    let res: any = await GetNomineeDetails();
    if (res.data && res.data.value) {
      setNomineeDetails(JSON.parse(res.data.value));
    } else openSRErrorPopup();
  };
  const submitForm = async () => {
    var payload = undefined;

    if (nominee.current) payload = nominee.current.submitData();
    else {
      props.setLoader(false);
      return nominee;
    }
    if (payload.acTyp || reqObj.acTyp) {
      props.setLoader(true);

      let resp = invOnlyAcc ? await CreateServiceRequestDetails(payload || reqObj) :  await createServiceReqNomin(payload || reqObj);
      
      let nomineePopup = localStorage.getItem("mandatePopup");
      if(nomineePopup == "nominee")
        localStorage.removeItem("mandatePopup");
      let consentList: any = localStorage.getItem("consentList");
      consentList = JSON.parse(consentList);
      if(consentList && consentList.length > 0){
        if(consentList[0].name === "nominee"){
          consentList.shift();
          consentList.length > 0 
          ? localStorage.setItem("consentList",consentList)
          : localStorage.removeItem("consentList");
        }
      }
      if (invOnlyAcc) {
        if (resp && resp.Id !== undefined && resp.Id !== 0) {
          localStorage.setItem("srId", resp.Id)
          // localStorage.setItem("nomPdf", resp.data.data)
          setTimeout(() => {
            openSRSuccessPopup();
          }, 1500)
        } else if (typeof resp === "string" && resp.includes(
              "Previous Request already open for this account-"
            )) {
          openExistSrPopup()
        }
        else openSRErrorPopup()
      } else {
        if (resp && resp.data && resp.data.srId) {
          localStorage.setItem("srId", resp.data.srId)
          localStorage.setItem("nomPdf", resp.data.data)
          setTimeout(() => {
            openSRSuccessPopup();
          }, 1500)
        } else if (resp && resp.error && resp.error.errCd === "SR0005") {
          openExistSrPopup()

        }
        else openSRErrorPopup()
      }
      }
      
  };
  const openSRSuccessPopup = () => {
    props.setLoader(false);
    let paramObj: any = {
      content: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":
        "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
      headerText: "We have received your request!",
      btnText: "Download Pre-filled form",
      popupType: "Success",
      type: "nomination"
    };

    props.onSubmit("nomination", paramObj);
  };
  const checkExistingNominSR = async () => {
    props.showFooter(true);
    setExistingNominationSR("");
    props.setBtnText("Submit");
    getNomineeDetails();
  };
  function downloadNomForm() {
    let url = process.env.PUBLIC_URL + "/documents/NominationForm.pdf";
    if (localStorage.getItem("lgnSrc") === "iphone") window.open(url, "_blank");
    else {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = url;
      link.download = "NominationForm.pdf";
      var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      link.dispatchEvent(evt);
      window.URL.revokeObjectURL(url);
    }
  }
  
  const openSRErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("nomination", {
      headerText: "There was some problem in raising service request. Please try again later.",
    });
  };
 
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("nomination", {
      headerText: "You have an active service request",
      content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  const isAccClouserOpen = serviceReqListArr?.length && serviceReqListArr.find((item:any) =>
    item.RequestType === 'Online Closure' && (item.RequestStatus === 'EsignSubmitted' || item.RequestStatus === 'Assigned' || item.RequestStatus === 'Open'  || item.RequestStatus === 'PendingForEsign')
  );
  useEffect(() => {
    if (isAccClouserOpen) {
      props.showFooter(false);
    } else {
      props.showFooter(true);
    }
  }, [isAccClouserOpen]);
  return (
    <>
    {
      (!isAccClouserOpen? 
        <>
          {existingNominationSR ? (
            <StatusScreen
              headerText="Nominee Modification in Process"
              desc="Another Nominee request is under process. Please raise any new requests only once those are processed."
              status="Pending"
            />
          ) : (
            <div className="nomination">
              <div className="CheckboxWrap">
                <div>
                  <h6>Options</h6>
                </div>
                <div className="payment-radio nominationRadio">
                  <div
                    className={
                      "display-flex" +
                      (!isNomineePresent(nomineeDet[0])
                        ? " radioContentInline"
                        : "")
                    }
                  >
                    {isNomineePresent(nomineeDet[0]) &&
                      nomineeDet.length > 0 &&
                      nomineeDet[0].TradingDetails.Minor !== "Yes" && (
                        <div className="radioBtn_wrap">
                          <RadioButton
                            list={payMethod[0]}
                            name="bnkName"
                            onChange={() => {
                              setNominType(payMethod[0].value);
                            }}
                            selected={nominType}
                          />
                          <p>Add same nominee details</p>
                        </div>
                      )}

                    <div className="radioBtn_wrap">
                      <RadioButton
                        list={payMethod[1]}
                        name="bnkName"
                        onChange={() => {
                          setNominType(payMethod[1].value);
                        }}
                        selected={nominType}
                      />
                      <p>I do not wish to nominate anyone</p>
                    </div>
                    {nomineeDet.length > 0 &&
                      nomineeDet[0].TradingDetails.Minor !== "Yes" && (
                        <div className="radioBtn_wrap">
                          <RadioButton
                            list={payMethod[2]}
                            name="bnkName"
                            onChange={() => {
                              setNominType(payMethod[2].value);
                            }}
                            selected={nominType}
                          />
                          <p>I wish to update nominee</p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="msg">
                    {invOnlyAcc ? (
                      <p className="blue-text">{Invmessage[nominType]}</p>
                    ) : <p className="blue-text">{message[nominType]}</p>}
              </div>

              {nominType === "replicate" && nomineeDet.length > 0 && (
                <Replication
                  nomineeDet={nomineeDet}
                  payload={(val: any) => {
                    setReqObj(val);
                  }}
                  enableSubmit={(val: any) => {
                    props.enableSubmit(val);
                  }}
                  ref={nominee}
                  setLoader={(val: any) => props.setLoader(val)}
                />
              )}
              {nominType === "optOut" && nomineeDet.length > 0 && (
                <OptOut
                  enableSubmit={(val: any) => {
                    props.enableSubmit(val);
                  }}
                  nomineeDet={nomineeDet}
                  onlyTrading = {(props.acntCategory === "Individual Outside DP" || props.acntCategory === "Individual Missing DP Details") ? 1 : 0 }
                  ref={nominee}
                  dpId={(obj: any) => {
                    setNomineeForm({
                      ...nomineeForm,
                      selectedDp: obj.dpId,
                      tradingUpd: obj.accType.includes("trading"),
                      dematUpd: obj.accType.toLowerCase().includes("demat"),
                    });
                  }}
                  setLoader={(val: any) => props.setLoader(val)}
                  showErrorPopup={() => {
                    openSRErrorPopup();
                  }}
                />
              )}
              {nominType === "updateNominee" && (
                <AddNewNominee
                  nomineeDet={nomineeDet}
                  onlyTrading = {(props.acntCategory === "Individual Outside DP" || props.acntCategory === "Individual Missing DP Details") ? 1 : 0 }
                  enableSubmit={(val: any) => {
                    props.enableSubmit(val);
                  }}
                  ref={nominee}
                  setNomineeForm={setNomineeForm}
                  loader={props.loader}
                  setLoader={(val: any) => props.setLoader(val)}
                  showErrorPopup={() => {
                    openSRErrorPopup();
                  }}
                />
              )}
            </div>
          )}
        </>
      :(props.loader? null : <p className="help-text red line-ht-standard">You have an ongoing account closure request. During this time, you cannot initiate any request.</p>))
    }
    </>
  );
});
